import React from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";

export default function ImportResultStep({ preview }) {
  const totals = preview?.totals || {};
  return (
    <Stack spacing={2.5}>
      <div>
        <Typography variant="h6" sx={{ fontWeight: 900 }}>Confirmación</Typography>
        <Typography variant="body2" color="text.secondary">
          La preparación y preview están completas. El commit se habilitará cuando exista el endpoint de confirmación de la siguiente instrucción.
        </Typography>
      </div>
      <Alert severity="warning">
        <strong>No se aplicó ningún cambio.</strong> Esta pantalla no simula una confirmación inexistente. El borrador temporal contiene {totals.created || 0} alta(s), {totals.updated || 0} actualización(es) y {totals.skipped || 0} fila(s) omitida(s) según la última preview.
      </Alert>
      <Button variant="contained" disabled>
        Confirmar importación
      </Button>
      <Typography variant="caption" color="text.secondary">
        Al cerrar el wizard se eliminará el borrador de forma best-effort. Ningún File se guarda en localStorage.
      </Typography>
    </Stack>
  );
}
